import React, { useState, useEffect } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import Header from "../partials/header";
import LeftSidebar from "../partials/leftSidebar";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import LicenseTabOne from "./licencesTabs/LicenseTabOne";
import LicenseTabTwo from "./licencesTabs/LicenseTabTwo";
import LicenseTabThree from "./licencesTabs/LicenseTabThree";
import { usePartnerIdContext } from "../../context/partnerIdContext";
import { getUserPriority } from "../../services/authService";
import { PROFILE_TYPE } from "../../helper/globalConstant";
import { getMethod } from "../../services/apiService";
import { DistributorsList } from "../sharedComponent/DistributorsList";
import { SelectedDistributorPartner } from "../sharedComponent/SelectedDistributorPartner";

function LicensesMain() {
  const { partnerId, setPartnerId } = usePartnerIdContext();
  const [activeTab, setActiveTab] = useState(0);
  const [userPriority, setUserPriority] = useState<any>();
  const [isReady, setIsReady] = useState(false);
  const [activeView, setActiveView] = useState<"distributors" | "licenses">(
    "licenses",
  );
  const [selectedDistributor, setSelectedDistributor] = useState<any>(null);
  const [distributorListData, setDistributorListData] = useState<any[]>([]);
  const [isLoadingDistributors, setIsLoadingDistributors] = useState(false);

  useEffect(() => {
    setActiveTab(0);
  }, [selectedDistributor]);

  useEffect(() => {
    fetchUserPriority();
  }, []);

  useEffect(() => {
    fetchUserPriority();
  }, []);

  const fetchUserPriority = async () => {
    let priority = getUserPriority();
    setUserPriority(priority);

    if (priority === PROFILE_TYPE.SUPER_ADMIN || priority === PROFILE_TYPE.DISTRIBUTOR) {
      setPartnerId("");
    }

    if (priority === PROFILE_TYPE.SUPER_ADMIN) {
      setActiveView("distributors");
      fetchDistributorsForCAdmin();
    } else {
      setActiveView("licenses");
    }
    
    setIsReady(true);
  };

  const fetchDistributorsForCAdmin = async () => {
    setIsLoadingDistributors(true);
    try {
      const response = await getMethod(`partner/users`);
      if (response?.data?.code === 200) {
        setDistributorListData(response.data?.result ?? []);
      }
    } catch (e) {
      console.error("Error fetching distributors", e);
    } finally {
      setIsLoadingDistributors(false);
    }
  };

  const handleTabChange = (event: any, newValue: any) => {
    setActiveTab(newValue);
  };

  const handleSelectDistributor = (distributor: any) => {
    setSelectedDistributor(distributor);
    setPartnerId(distributor.userId);
    setActiveView("licenses");
  };

  const getBreadcrumbs = () => {
    const isCAdmin = userPriority == PROFILE_TYPE.SUPER_ADMIN;
    const items = [];

    if (!isCAdmin) return null;

    if (isCAdmin) {
      items.push(
        <span
          key="bc-dist"
          className={`bc-item ${activeView === "distributors" ? "active" : "inactive"}`}
          style={{
            cursor: activeView !== "distributors" ? "pointer" : "default",
          }}
          onClick={() => {
            setActiveView("distributors");
            setSelectedDistributor(null);
            setPartnerId("");
          }}
        >
          Distributors
        </span>,
      );
      if (activeView === "licenses") {
        items.push(
          <span key="sep1" className="bc-sep">
            ›
          </span>,
        );
        items.push(
          <span key="bc-lic" className="bc-item active">
            Licenses
          </span>,
        );
      }
    }

    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          padding: "14px 24px 14px 100px",
          bgcolor: "#1f2f34",
          borderBottom: "1px solid #17B2EB22",
        }}
      >
        {items}
      </Box>
    );
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Header title="Licenses" breadCrumbBar={getBreadcrumbs()} />
      <Box sx={{ display: "flex" }}>
        <LeftSidebar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            marginTop: userPriority == PROFILE_TYPE.SUPER_ADMIN ? 14 : 7,
            padding: "0",
          }}
        >
          <Box
            // p={3}
            // pt={0}
            sx={{
              backgroundColor: "#03171F",
              minHeight: "calc(100vh - 150px)",
            }}
          >
            {isReady && (
              <>
                <Box sx={{ my: activeView === "licenses" ? 3 : 0, mx: 3 }}>
                  <SelectedDistributorPartner
                    selectedDistributor={selectedDistributor}
                  />
                </Box>

                {activeView === "distributors" && (
                  <Box p={3} pt={0}>
                    <DistributorsList
                      distributors={distributorListData}
                      isLoading={isLoadingDistributors}
                      onSelect={handleSelectDistributor}
                    />
                  </Box>
                )}

                {activeView === "licenses" && (
                  <TabContext value={activeTab.toString()}>
                    <Box sx={{ borderBottom: 1, borderColor: "#313838" }}>
                      <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        indicatorColor="primary"
                        textColor="inherit"
                        variant="fullWidth"
                      >
                        <Tab
                          label="Licenses"
                          value={0}
                          style={{ textTransform: "none" }}
                        />
                        {(userPriority === PROFILE_TYPE.SUPER_ADMIN ||
                          userPriority === PROFILE_TYPE.DISTRIBUTOR) && (
                          <Tab
                            label="Import Licenses"
                            value={2}
                            style={{ textTransform: "none" }}
                          />
                        )}
                      </Tabs>
                    </Box>
                    <TabPanel value="0">
                      <LicenseTabOne />
                    </TabPanel>
                    <TabPanel value="1">
                      <LicenseTabTwo />
                    </TabPanel>
                    {(userPriority === PROFILE_TYPE.SUPER_ADMIN ||
                      userPriority === PROFILE_TYPE.DISTRIBUTOR) && (
                      <TabPanel value="2">
                        <LicenseTabThree setActiveTab={setActiveTab} />
                      </TabPanel>
                    )}
                  </TabContext>
                )}
              </>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default LicensesMain;
